
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLightIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.136 8.246C5.136 4.252 8.305 1 12.125 1s6.988 3.252 7.012 7.246c0 2.415-1.165 4.52-2.796 5.739v1.793c0 .502-.42.909-.908.957l-6.406.526h-.094a.943.943 0 0 1-.652-.263c-.186-.168-.35-.43-.35-.694v-2.343c-1.863-1.315-2.795-3.276-2.795-5.715zm9.318 5.189c0-.335.163-.67.466-.837 1.467-.813 2.306-2.44 2.33-4.352 0-2.942-2.307-5.333-5.125-5.333-2.819 0-5.125 2.391-5.102 5.333 0 1.96.746 3.395 2.353 4.352.28.191.42.502.42.837v1.841l4.658-.383v-1.458z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m15.363 19.796-6.36.478h-.07c-.489 0-.885-.383-.931-.885a.954.954 0 0 1 .861-1.028l6.36-.479a.918.918 0 0 1 1.001.885.953.953 0 0 1-.861 1.029zm-2.027 3.013-2.283.19h-.07c-.489 0-.885-.382-.931-.884a.954.954 0 0 1 .862-1.028l2.306-.191a.926.926 0 0 1 .978.884.953.953 0 0 1-.862 1.029zm2.493-14.587c-.047.43-.396.765-.816.765h-.07a.826.826 0 0 1-.722-.909c.14-1.363-1.024-1.865-1.164-1.913a.87.87 0 0 1-.49-1.076c.14-.43.606-.67 1.025-.502.862.31 2.446 1.483 2.237 3.635z",
  fill: "#000"
})));

      const __svgRaw = "<svg width=\"25\" height=\"24\" viewBox=\"0 0 25 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.136 8.246C5.136 4.252 8.305 1 12.125 1s6.988 3.252 7.012 7.246c0 2.415-1.165 4.52-2.796 5.739v1.793c0 .502-.42.909-.908.957l-6.406.526h-.094a.943.943 0 0 1-.652-.263c-.186-.168-.35-.43-.35-.694v-2.343c-1.863-1.315-2.795-3.276-2.795-5.715zm9.318 5.189c0-.335.163-.67.466-.837 1.467-.813 2.306-2.44 2.33-4.352 0-2.942-2.307-5.333-5.125-5.333-2.819 0-5.125 2.391-5.102 5.333 0 1.96.746 3.395 2.353 4.352.28.191.42.502.42.837v1.841l4.658-.383v-1.458z\" fill=\"#000\"/>\r\n    <path d=\"m15.363 19.796-6.36.478h-.07c-.489 0-.885-.383-.931-.885a.954.954 0 0 1 .861-1.028l6.36-.479a.918.918 0 0 1 1.001.885.953.953 0 0 1-.861 1.029zM13.336 22.809l-2.283.19h-.07c-.489 0-.885-.382-.931-.884a.954.954 0 0 1 .862-1.028l2.306-.191a.926.926 0 0 1 .978.884.953.953 0 0 1-.862 1.029zM15.829 8.222c-.047.43-.396.765-.816.765h-.07a.826.826 0 0 1-.722-.909c.14-1.363-1.024-1.865-1.164-1.913a.87.87 0 0 1-.49-1.076c.14-.43.606-.67 1.025-.502.862.31 2.446 1.483 2.237 3.635z\" fill=\"#000\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/light-icon.a91f3372e2512bcf7279e8e06df6ac66.svg"),
        {
          React: SvgLightIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      